import { withNamespaces } from 'react-i18next';
import { Card, CardBody, CardTitle } from 'reactstrap';
import SimpleBar from 'simplebar-react';

import DateUtils from 'src/services/utils/DateUtils';
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import { HistoryLogDescriptionCreator } from 'src/modules/3rd-party-management/services/HistoryLogDescriptionCreator';

import useSupplierOverviewRecentActivity from './hooks/useSupplierOverviewRecentActivity';

const dateUtils = new DateUtils();
const logDescriptionCreator = new HistoryLogDescriptionCreator();

const RecentActivitySkeleton = () => (
    <>
        <div className="dt-field dt-skeleton mb-4" style={{ width: '30%' }} />

        <div className="d-flex align-items-center flex-row justify-content-start mb-4">
            <div className="dt-field dt-skeleton me-2" style={{ width: '26px', borderRadius: '50%' }} />
            <div className="w-100">
                <div className="dt-field dt-skeleton mb-2" style={{ width: '50%' }} />
                <div className="dt-field dt-skeleton" style={{ width: '90%' }} />
            </div>
        </div>

        <div className="d-flex align-items-center flex-row justify-content-start mb-4">
            <div className="dt-field dt-skeleton me-2" style={{ width: '26px', borderRadius: '50%' }} />
            <div className="w-100">
                <div className="dt-field dt-skeleton mb-2" style={{ width: '50%' }} />
                <div className="dt-field dt-skeleton" style={{ width: '90%' }} />
            </div>
        </div>

        <div className="d-flex align-items-center flex-row justify-content-start mb-4">
            <div className="dt-field dt-skeleton me-2" style={{ width: '26px', borderRadius: '50%' }} />
            <div className="w-100">
                <div className="dt-field dt-skeleton mb-2" style={{ width: '50%' }} />
                <div className="dt-field dt-skeleton" style={{ width: '90%' }} />
            </div>
        </div>

        <div className="d-flex align-items-center flex-row justify-content-start mb-4">
            <div className="dt-field dt-skeleton me-2" style={{ width: '26px', borderRadius: '50%' }} />
            <div className="w-100">
                <div className="dt-field dt-skeleton mb-2" style={{ width: '50%' }} />
                <div className="dt-field dt-skeleton" style={{ width: '90%' }} />
            </div>
        </div>
    </>
);

const RecentActivity = ({
    t,
    supplierId,
}) => {
    const fetchRecentActivityQuery = useSupplierOverviewRecentActivity({
        supplierId,
        t,
    });

    if (
        fetchRecentActivityQuery.isLoading
        || fetchRecentActivityQuery.isFetching
        || !Array.isArray(fetchRecentActivityQuery.data)
    ) {
        return <RecentActivitySkeleton />;
    }

    const lastActivities = fetchRecentActivityQuery.data;

    return (
        <Card>
            <CardBody>
                <CardTitle className="overview-section-title mb-4">
                    {t('Recent Activity')}
                </CardTitle>

                <SimpleBar style={{ height: '318px' }}>
                    <ul className="list-unstyled activity-wid">
                        {lastActivities.map((activity, index) => (
                            <li key={activity.id || index} className="activity-list">
                                <div className="activity-icon avatar-xs">
                                    <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                        <i className="ri-edit-2-fill" />
                                    </span>
                                </div>
                                <div>
                                    <div>
                                        <h5 className="font-size-13">
                                            {dateUtils.convertDateToDate(activity.created_at, INTERNATIONAL_DATE_FORMAT)}
                                            <small className="ml-3 text-muted">
                                                {' '}{dateUtils.convertDateToDate(activity.created_at, 'HH:mm')}
                                            </small>
                                        </h5>
                                    </div>

                                    <div>
                                        <p className="text-muted mb-0">
                                            {t(logDescriptionCreator.createFromApiData(activity))}
                                        </p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </SimpleBar>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(RecentActivity);
